<template>
	<div class="live-discuss">
		<div class="mesContainer" ref="mesContainer">
			<van-pull-refresh v-if="!isEmpty" v-model="isLoading" @refresh="getChatRecord" pullimg-text="下拉查看历史消息" loosing-text="释放查看历史消息" :disabled="disabledPull">
				<div class="message-item" v-for="(item,index) in topicList" :class="[item.direction,item.isAdmin]" :key="index">
					<img :src="item.avatar" alt="">
					<div class="content">
						<span></span>
						<p v-html="item.msg"></p>
					</div>
				</div>
			</van-pull-refresh>
			<div class="noData" v-if="isEmpty">
				<img src="../../assets/images/noData2.png" alt="">
				<p>欢迎大家参与讨论</p>
			</div>
		</div>
		<div class="comment-input flex">
			<input type="text" placeholder="说点什么..."   ref="commentInput" v-model="content">
			<img src="@/assets/images/giveLike.png" alt="" class="give-like" @click="giveLike" v-if="isWX">
			<button @click="sendDiscuss">发送</button>
		</div>
	</div>
</template>
<script>
import {PersoanalUserInfo,Signature,MeetingChat,MeetingchatList,MeetinganonymousChat} from "../../config/interface.js"
	export default{
		props:{
			admin:Array
		},
		data(){
			
			return{
				disabledPull:false,   // 禁用下拉
				isLoading:false,
				isEmpty:false,
				content:'',
				userInfo:this.$store.state.userInfo,
				value:0,
				websock:'',
				obj:'',
				room_id:this.$route.query.id,      //房间号
				connectWebSocket:false,     //websocket是否连接
				pingTimer:null,             //定时器
				topicList:[],               //话题列表
				userId:0,
				signatureInfo:{},    //签名信息
				last_id:0,
				isWX:false
			}
		},
		created(){

		},
		watch:{
			topicList(oldData,newData){
				this.isEmpty=newData.length>0?false:true;
			}
		},
		mounted(){
				this.isWX=common.is_weixin()
				if(common.is_weixin()){
					this.getSignature();
				}else{
					this.getanonymousChat();
				}
				let keyTimer = null;
				document.body.addEventListener('focusin', () => {
					//软键盘弹起事件
					clearInterval(keyTimer);
				});
				document.body.addEventListener('focusout', () => {
				    // 软键盘关闭事件
					window.scrollTo(0, 0);
				    keyTimer = setTimeout(() => {
				      if (window.pageYOffset > 0) {
				        window.scrollTo(0, 0);
				      }
				    }, 200);
				})
				  
		},
		methods:{
			//获取用户信息
			getUserInfo(){
					const url=PersoanalUserInfo;
					let params={};
					const method='POST';
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							this.userInfo=data;
							localStorage.setItem('userInfo',JSON.stringify(data));
							this.$store.dispatch('storageUserInfo',data);						
							this.initWebSocket();
							this.getLiveChat();
							
						}
					})
				
			},
			//得到签名
			getSignature(){
				if(Object.keys(this.signatureInfo).length==0){
					const url=Signature;
					const method='POST';
					let params={}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							let data=res.data;
							this.signatureInfo=data;
							if(!this.userInfo){
								this.getUserInfo();
							}else{
								this.initWebSocket();
								this.getLiveChat();
							}
										
						}
					})
					
				}else{
					if(!this.userInfo){
						this.getUserInfo();
					}
				}


			},
			//查看聊天记录
			getChatRecord(){
				if(common.is_weixin()){
					this.getLiveChat()
				}else{
					this.getanonymousChat();
				}
			},
			//查看匿名聊天记录
			getanonymousChat(){
				const url=MeetingchatList;
				let params={
					session_id:this.room_id,
					last_id:this.last_id
				}
				let method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						if(data.length>0){
							data.forEach((item,index)=>{
								let obj={
									avatar:require('@/assets/images/default_user.png'),
									msg:item.uuid+': '+item.content,
									direction:'left',		
								}
								this.topicList.unshift(obj);
															
							})
							this.last_id==0?this.backBottom():'';
							this.last_id=data[data.length-1].id;
							
							
						}else{
							if(this.last_id!=0){
								common.toast('已经到顶了',1000);    //第一次为空时不弹出弹窗
								this.disabledPull=true;
							}
							
						}
						this.isEmpty=this.topicList.length>0?false:true;
						this.isLoading=false;
					}
				})
			},
			//查看实时聊天记录
			getLiveChat(){
				const url=MeetingChat;
				let params={
					session_id:this.room_id,
					last_id:this.last_id
				}
				const methos='POST';
				fetch(url,params,methos)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.length>0){
							data.forEach((item,index)=>{
								let obj={
									avatar:item.avatar,
									msg:`<i>${item.nickname} :</i> ${item.params.body}`,
									direction:this.userInfo.ecs_id==item.uasid?'right':'left',
									isAdmin:item.params.from_admin?'admin':''	
								}
								this.topicList.unshift(obj);
								console.log(obj);							
							})
							this.last_id==0?this.backBottom():'';
							this.last_id=data[data.length-1].id;
							
							
						}else{
							if(this.last_id!=0){
								common.toast('已经到顶了',1000);    //第一次为空时不弹出弹窗
								this.disabledPull=true;
							}
							
						}
						this.isEmpty=this.topicList.length>0?false:true;
						this.isLoading=false;
					}
				})
			},
			//初始化weosocket
			initWebSocket(){ 
        		const wsuri = this.signatureInfo.ws_url;
        		this.websock = new WebSocket(wsuri);
        		this.websock.onopen =(data)=>{
        			console.log('连接成功')
        		};        
        		this.websock.onmessage = (event)=>{
        			this.websocketonmessage(event);
        		};               
        		this.websock.onerror = ()=>{
        			this.websocketonerror();
        		};       
        		this.websock.onclose =()=>{
        			this.websocketclose();
      			};
      		},
      		//数据发送
      		websocketSendMessage(){
      			let params={
      				"action": "send_to_all_room_member",
					"params": {
					    "raw": {
					      "body": this.content
					    }
					},
					"room_id":this.room_id
      			}
      			this.websock.send(JSON.stringify(params));
      			this.content='';
      			
      		},
		    //连接建立失败重连
	      	websocketonerror(){
	        	this.initWebSocket();
	      	},
	      	//数据接收
	      	websocketonmessage(res){ 
	      		if (res.data == "pong") return;
	        	var data = JSON.parse(res.data);
	        	//连接成功  加入房间
	        	if(data.code==201){
					this.joinRoom();
					this.connectWebSocket=true;
					this.keepSocket();    
				}else if(data.code==200){
					//正常响应
					console.log(data.action);
					let str=data.action;
					let userId=this.userInfo?this.userInfo.ecs_id:0;
					switch(str){
						//接收到群发信息
						case 'send_to_all_room_member':
						let receiveData=data.data.msg_list[0];
						let obj={
							avatar:receiveData.avatar,
							msg:`<i>${receiveData.nickname} :</i> ${receiveData.body}`,
							direction:userId==receiveData.from_id?'right':'left',
						}
						this.topicList.push(obj);
						this.backBottom();
						break;
						//消息正在审核中
						case 'wait_check_msg':
						common.toast(data.message,1500);
						break;
						
					}
				}else if(data.code == 301 || data.code == 403){
					//被迫下线  签名错误或者验证已过期
					this.getSignature();
			
				}
	      	},
	      	//关闭websocket
	      	websocketClose(){
	      		this.websock.close();
	      	},
	      	//加入房间
	      	joinRoom(){
	      		let nickname=this.userInfo.nickname;
			 	let avatar=this.userInfo.avatar;
	      		let obj={
	      			"type": "room",
	        		"action":"join_room",
	        		"params": {
	        			"nickname":nickname,
	        			"avatar":avatar
	        		},
	        		"room_id":this.room_id
	      		}
	      		this.websock.send(JSON.stringify(obj));
	      	},
		  	//  维持心跳  WebSocket Ping Pong
		    keepSocket(){
			      console.log("ping");
			      if (this.connectWebSocket) {
			    	  this.websock.send("ping");
			      }
			      this.pingTimer = setTimeout(()=> {
			        this.keepSocket();
			      }, 1000 * 30);
		  	},
		  	backBottom(){
		  		let ele=this.$refs.mesContainer;
				  let scrollTop=0;
				  this.$nextTick(()=>{
					 if(ele.scrollHeight>ele.clientHeight){
						scrollTop=ele.scrollHeight-ele.clientHeight+44;
						this.$refs.mesContainer.scrollTop=scrollTop;
				  	}
				  })
		  	},
	      	websocketclose(e){  
	        	console.log('断开连接',e);
			  },
			//发送匿名聊天
			sendanonymousChat(){
				const url=MeetinganonymousChat;
				let params={
					session_id:this.room_id,
					content:this.content
				}
				let code='';
				if(localStorage.getItem('uuid')){
					code=localStorage.getItem('uuid');

				}else{
					for(let i=0;i<=7;i++){
						let num=Math.floor(Math.random()*10);
						code+=num;
					}
					localStorage.setItem('uuid',code)
				}
				params.uuid=code;
				let method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let obj={
							avatar:require('@/assets/images/default_user.png'),
							msg:params.uuid+': '+this.content,
							direction:'left',		
						}
						this.topicList.push(obj);
						this.content='';
						
					}
				})
			},
			//发送讨论
			sendDiscuss(){
				if(common.is_weixin()){
					this.content!=''?this.websocketSendMessage():'';
				}else{
					this.content!=''?this.sendanonymousChat():'';
				}
				
			},
			//点赞
			giveLike(){
				this.content='[emo:1]'
				this.content!=''?this.websocketSendMessage():'';
			},
		},
		destroyed(){
			//建立连接  才可以关闭
			if(this.connectWebSocket){
				clearTimeout(this.pingTimer);
			    this.websocketClose();
			}
		}
	}
</script>
<style lang="scss">
	.live-discuss{
		.mesContainer{
			padding:15px;
			position:absolute;
			overflow:auto;
			top:0px;
			bottom:44px;
			width:100%;
			box-sizing:border-box;
			.van-pull-refresh{
				min-height:100%;
			}
			.message-item{
				@include flex(row);
				align-items:center;
				margin-bottom:15px;
				img{
						width:40px;
						height:40px;
						border-radius:50%;
				}
				.content{
					position:relative;
					margin-left:20px;
					padding:10px;
					background:#7b75754d;
					border-radius:2px;
					span{
						position:absolute;
						top:50%;
						transform: translate(0,-50%);
						left:-20px;
						display:inline-block;
						border-top:10px solid transparent;
						border-bottom:10px solid transparent;
						border-left:10px solid transparent;
						border-right:10px solid #7b75754d;
					}
					p{
						max-width:200px;
						word-wrap:break-word;
						i{
							font-style:normal;
						}
					}
				}
			}
			.admin{
				p{
					// color:$color-main;
					
				}
			}
			.right{
				transform: rotateY(180deg);
				-ms-transform:rotateY(180deg); 
   				-webkit-transform:rotateY(180deg); 
				img,p{
					transform: rotateY(180deg);
					-ms-transform:rotateY(180deg); 
   					-webkit-transform:rotateY(180deg); 
				}

			}
		}
		.comment-input{
			position:absolute;
			bottom: 0px;
			width:100%;
			height:44px;
			padding:5px 15px;
			align-items:center;
			background-color:#f4f4f4;
				input{
					line-height:34px;
					padding-left:5px;
					flex:1;
					border:0px;
					font-size:15px;
					color:#000;
				}
				.give-like{
					width:25px;
					position: absolute;
					right:75px;
				}
				button{
					margin-left:5px;
					/*width:52px;*/
					height:28px;
					border:0px;
					padding:0 10px;
					line-height:28px;
					text-align:center;
					background-color:$color-main;
					font-size: 14px;
					color:#fff;
				}
			}
		.noData{
			text-align:center;
			img{
				width:200px;
				margin-top:20px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Meeting/Discuss.vue